"use client";

import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const facilities = [{
  id: 1,
  title: "The Grand Azure Resort",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/luxury_hotel_azure.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/luxury_hotel_azure.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/luxury_hotel_azure.png-wvc-sizes",
  alt: "Luxury beachfront resort with infinity pool"
}, {
  id: 2,
  title: "Emerald Peak Lodge",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/mountain_retreat_emerald.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/mountain_retreat_emerald.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/mountain_retreat_emerald.png-wvc-sizes",
  alt: "Modern mountain lodge with panoramic views"
}, {
  id: 3,
  title: "Urban Oasis Suites",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/city_luxury_suites.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/city_luxury_suites.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/city_luxury_suites.png-wvc-sizes",
  alt: "Sleek skyscraper hotel in the city center"
}, {
  id: 4,
  title: "Serenity Sands Villa",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/private_island_villa.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/private_island_villa.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/private_island_villa.png-wvc-sizes",
  alt: "Private overwater villa with crystal clear water"
}, {
  id: 5,
  title: "Royal Heritage Palace",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/historic_palace_hotel.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/historic_palace_hotel.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/historic_palace_hotel.png-wvc-sizes",
  alt: "Historic palace converted into a luxury hotel"
}];
export default function ClinicFacilityGallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="253226" id="hotelshowcasegallery" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center">
          <h2 className="font-default text-4xl font-bold tracking-tight text-foreground sm:text-5xl">
            Kiemelt Szálláshelyeink
          </h2>
          <p className="mt-4 text-xl text-muted-foreground max-w-2xl mx-auto font-default">
            Fedezze fel a világ legexkluzívabb hoteleit és üdülőhelyeit, amelyeket szakértőink válogattak össze az Ön kényelméért.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {facilities.map((facility, index) => <div key={facility.id} data-index={index} className="group flex flex-col gap-4">
              <div className="overflow-hidden rounded-2xl shadow-lg transition-all duration-500 hover:shadow-xl border border-border/40 bg-card/50 backdrop-blur-md">
                <AspectRatio ratio={4 / 3}>
                  <img src={facility.src} data-wvc-srcset={facility.srcset} data-wvc-sizes={facility.sizes} alt={facility.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                </AspectRatio>
              </div>
              <h3 className="font-serif text-xl font-semibold text-foreground text-center truncate px-2">
                {facility.title}
              </h3>
            </div>)}
        </div>
      </div>
    </section>;
}